export default "__VITE_ASSET__gLs5eIRu__"